<template>
  <ModalDialog
    :dialog="show"
    :width="600"
    @input="$emit('close', $event)"
  >
    <template slot="title">
      {{ $t('views.surveyApp.title') }}
    </template>
    <template slot="body">
      <div  :class="[
          'section-mh d-flex flex-nowrap flex-column align-center justify-start',
        ]"
        style="max-width: 100%">
        <h2 class="mt-4">{{ $t('views.surveyApp.subtitle') }}</h2>
        <stars-score
          class="mt-2"
          :max="4"
          :size="'3.5rem'"
          @input="starsScore = $event"
        />
      </div>
        <v-scroll-y-reverse-transition>
          <v-textarea
            v-if="starsScore > 0"
            class="mt-6"
            filled
            hide-details="auto"
            :auto-grow="true"
            no-resize
            v-model="ratingComment"
            :rows="$vuetify.breakpoint.mdAndUp ? 3 : 7"
            :disabled="submitting"
            :placeholder="$t('views.surveyApp.valorationPlaceholder')"
          />
        </v-scroll-y-reverse-transition>
        <div class="d-flex flex-wrap justify-end">
          <v-btn
            v-if="starsScore > 0"
            class="mt-4"
            color="primary"
            right
            dark
            :block="!$vuetify.breakpoint.mdAndUp"
            @click="acceptClosing()"
            :loading="submitting"
          >
            {{ $t('commons.send') }}
          </v-btn>
        </div>
    </template>
  </ModalDialog>
</template>

<script>
import { ModalDialog, StarsScore } from '@/components';

export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ModalDialog,
    StarsScore,
  },
  data() {
    return {
      opentext: false,
      submitting: false,
      starsScore: 0,
      ratingComment: null,
      show: this.visible,
    };
  },
  methods: {
    async acceptClosing() {
      try {
        this.submitting = true;
        await this.client.survey(this.starsScore, this.ratingComment);
        this.$emit('message', { message: this.$t('views.surveyApp.thanks'), color: 'green lighten-1' });
      } catch {
        this.$emit('message', { message: this.$t('views.surveyApp.error'), color: 'red lighten-1' });
      }
      this.submitting = false;
      this.$emit('close');
    },
  },
  created() {
    this.client = this.$api.getClient('survey');
  },
};
</script>
